export default "__VITE_ASSET__BT258qgq__"